"use client";
import React from "react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import BackButton from "@/components/ui/BackButton";

type Props = {
  title: string;
  children: React.ReactNode;
  footerLeft?: React.ReactNode;
  className?: string;
  showBack?: boolean;
};

export default function PageCard({ title, children, footerLeft, className, showBack = true }: Props) {
  return (
    <Card className={["max-w-5xl mx-auto mt-3 md:mt-4 bg-background", className || ""].join(" ")}> 
      <CardHeader className="flex flex-row items-center gap-3">
        {showBack && <BackButton />}
        <CardTitle id="page-title" tabIndex={-1} className="outline-none">{title}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">{children}</CardContent>
      {footerLeft ? (
        <CardFooter className="justify-start">{footerLeft}</CardFooter>
      ) : null}
    </Card>
  );
}
